<template>
  <div>
    <v-spacer></v-spacer>
    <h1 class="title">{{ $t('customer.account.title') }}</h1>
    
    <!-- MODAL NEW CONFIGURATION  -->
    <SalesforceConfigurationFormEdit
      v-if="selectedConfigurationShowDialog"
      @close-dialog="selectedConfigurationCloseDialog"
      @save-account="selectedConfigurationSave"
      showDialogEditConfiguration="true"
      :configuration="selectedConfiguration"
    />

    <!-- MODAL EDIT CONFIGURATION  -->
    <SalesforceConfigurationFormAdd
      v-if="newAccountShowDialog"
      @close-dialog="newAccountCloseDialog"
      @save-account="newAccountSave"
      showDialogNewConfiguration="true"
    />

    <v-container fluid>
      <v-row justify="center">
        <v-col
          cols="8"
          xs="10"
          sm="10"
        >
          <v-row justify="center">
            <v-col
              v-for="(item, i) in configItems"
              :key="i"
              cols="12"
              xl="5"
              lg="5"
              md="5"
              sm="10"
              xs="12"
            >
              <v-card
                class="px-4 py-4"
                elevation="10"
                height="100%"
              >
                <CardTitleWithTooltip>
                  <template v-slot:title>
                      {{ item.configLabel }}
                  </template>
                  <template v-slot:tooltip>
                      {{ $t('customer.account.configurationTooltip') }}
                  </template>
                </CardTitleWithTooltip>

                <v-card-text 
                  class="px-1 py-2 indigo--text"
                >
                  <v-container class="py-0">
                    <v-row>
                      <v-col cols="3" class="px-1 py-0">
                        <p class="font-weight-bold body text-left text-subtitle1">{{ $t('customer.account.accountNumber') }}:</p>
                      </v-col>
                      <v-col cols="9" class="pa-0">
                        <p class="font-weight-regular body text-left">{{ customerProfile.accountId }}</p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="3" class="px-1 py-0">
                        <p class="font-weight-bold body text-left">{{ $t('customer.account.crmInstance') }}:</p>
                      </v-col>
                      <v-col cols="9" class="pa-0">
                        <p class="font-weight-regular body text-left">{{ customerProfile.crmInstance }}</p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="3" class="px-1">
                        <p class="font-weight-bold body text-left">{{ $t('customer.account.widgetUrl') }}:</p>
                      </v-col>
                      <v-col cols="9" class="pa-0">
                        <p class="font-weight-regular body text-left">
                          {{ getHostName }}/widget/app/{{ item.configId }}{{getWidgetSubURL}}
                          <Copy2Clipboard
                            :valueToCopy="getHostName + '/widget/app/' + item.configId + getWidgetSubURL"
                          />
                        </p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions class="px-2 py-0 d-flex justify-space-around">
                  <v-btn 
                    v-bind="size" 
                    class="px-1" 
                    @click="selectedConfigurationOpenDialog(item)" 
                    color="#173862"
                    dark
                  >
                    <v-icon left>mdi-pencil</v-icon>{{ $t('customer.account.configuration') }}
                  </v-btn>
                  <v-btn 
                    v-bind="size" 
                    class="px-1" 
                    @click="openWidgetSettings(item)" 
                    color="orange darken-1"
                    dark
                  >
                    <v-icon left>mdi-cog-outline</v-icon>{{ $t('customer.account.widgetSettings') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              xl="5"
              lg="5"
              md="5"
              sm="10"
              xs="12"
            >
              <v-card
                class="px-4 py-4 new-config-card"
                elevation="10"
                height="100%"
              >
                <CardTitleWithTooltip>
                  <template v-slot:title>
                    {{ $t('customer.account.addConfiguration') }}
                  </template>
                  <template v-slot:tooltip>
                    {{ $t('customer.account.addConfigurationTooltip') }}
                  </template>
                </CardTitleWithTooltip>

                <v-card-text 
                  class="pa-2 justify-center text--disabled"
                >
                  {{ $t('customer.account.addConfigurationDescription') }}
                </v-card-text>  
                <v-card-actions 
                  class="px-3 py-6 mt-4 justify-center" 
                  height="180px"
                >
                  <div class="align-center">
                    <v-btn 
                      @click="newAccountShowDialog = true"
                      fab 
                      dark 
                      color="primary"
                      x-large
                    >
                      <v-icon dark x-large>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                 
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { customerMixin } from '../mixins/customerMixins'
import customerAccountsMixin from '../mixins/customerAccountMixins'
import resizeMixin from '../mixins/resizeMixins'

export default {
  mixins: [customerMixin, customerAccountsMixin, resizeMixin],
  created() {
    // get Customer CRM Config 
    const configItems = this.$store.getters['users/getCustomerCrmConfig'];

    // get Customer Profile data 
    const customerProfile = this.$store.getters['users/getCustomerProfile'];

    // populate the Configuration with the values from login response / storage
    this.configItems = [...configItems]

    // populate the customerProfile with the values from login response
    this.customerProfile = { ...customerProfile }
  },
  components: {
    CardTitleWithTooltip: require('../components/CardTitleWithTooltip').default,
    SalesforceConfigurationFormAdd: () => import('@/components/SalesforceConfigurationFormAdd'),
    SalesforceConfigurationFormEdit: () => import('@/components/SalesforceConfigurationFormEdit'),
    Copy2Clipboard: () => import('@/components/Copy2Clipboard')
  },
  methods: {
    openWidgetSettings(itemConfig) {
      // redirect to customerWidgetConfig 
      this.$router.push({
        name: 'customerWidgetConfig',
        params: {
          itemConfig
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  /* customer configuration card */
  .new-config-card {
      background-color: #ffffff !important;
      border: 3px dashed #173862 !important;
  }

  .tooltip-top-right {
    opacity: 0.5;
    position:absolute;
    top:0;
    right:0;
  }
</style>
